export const verifyIcon = (value: string) => {
  if (
    value === "whatsapp" ||
    value === "sms" ||
    value === "chatbot" ||
    value === "email" ||
    value === "portal" ||
    value === "ligacao" ||
    value === "agenteVirtual" ||
    value === "webchat"
  ) {
    return value;
  }
  return "whatsapp";
};
